<div id="shareSignedDocument" class="modal fade"  data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="modal-title">{{'Send as attachment:' | translate}} {{document?.name}}</h5>
      </div>
      <!--<form #form="ngForm" novalidate>-->
        <div class="modal-body">
          <div class="row">
            <div class="form-group">
              <div class="content-group">
                <input type="text" class="tags-input" [placeholder]="'+ Email address' | translate"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <textarea class="form-control" [(ngModel)]="message" [placeholder]="'Add Message' | translate" name="messge" #messge="ngModel" rows="6" cols="50"> </textarea>
            </div>
          </div>
        </div>
        <hr>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button type="button" class="btn btn-default active" (click)="share()" [disabled] = "emailItems.length == 0" data-dismiss="modal" translate>Share</button>
        </div>
     <!-- </form>-->
    </div>
  </div>
</div>
